/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ActivityGetRequest} from '@cash-web/protos/squareup/cash/activity/api/v1/service.pb'
import {ActivityGetResponse} from '@cash-web/protos/squareup/cash/activity/api/v1/service.pb'


export const activityGet = (request: ActivityGetRequest, options?: CashRequestOptions) => post<ActivityGetRequest, ActivityGetResponse>("/2.0/cash/activity-get", request, {...options, rejectOnError: true })